import { Avatar, AvatarFallback, AvatarImage } from '@src/design-system/avatar';
import { CustomErrorMessage } from '@src/design-system/error-message';
import { Label } from '@src/design-system/label';
import { AvatarUploadWithCrop } from '@src/design-system/molecules/avatar-upload-with-crop';
import { PhoneNumberInput } from '@src/design-system/phone-number-input';
import { Textfield } from '@shared/fields/text-field';
import { ErrorMessage, useFormikContext } from 'formik';
import { Edit2 } from 'iconsax-react';
import { useRef } from 'react';
import userApi from '@shared/services/user-api';
import type { TUser } from '@shared/types/user';

const EditRegistrationInfo = () => {
  const uploadRef = useRef<HTMLDivElement | null>(null);
  const { values, setFieldValue } = useFormikContext<TUser>();
  const { mutateAsync } = userApi.useUpdate();

  return (
    <div className='bg-white rounded-xl p-5 mb-5'>
      <p className='text-gray-600 font-medium text-base mb-6'>
        Registration Information
      </p>
      <div
        className='relative max-w-15'
        onClick={() => uploadRef.current?.click()}
      >
        <Avatar className='size-16 border border-gray-100 mb-6'>
          <AvatarImage src={values?.avatar} />
          <AvatarFallback
            className='text-2xl'
            colorId={values?.id}
          >
            {values?.first_name?.substring(0, 1)}
            {values?.last_name?.substring(0, 1)}
          </AvatarFallback>
        </Avatar>
        <Edit2
          size='24'
          className='absolute bottom-0 right-0 p-1 z-10 bg-white rounded-full'
          cursor='pointer'
          variant='TwoTone'
          color='var(--color-gray-800)'
        />
      </div>
      <div className='hidden'>
        <AvatarUploadWithCrop
          name='file'
          ref={uploadRef}
          allowedFormats='.jpg, .png, .svg'
          maxSize='800x400px'
          onCropped={async ({ file, previewUrl }) => {
            await mutateAsync({ id: values.id, avatar: file });
            setFieldValue('avatar', previewUrl);
          }}
        />
      </div>
      <Textfield
        name='first_name'
        type='text'
        placeholder='Enter First Name'
        label='First Name'
        className='mb-3'
      />
      <Textfield
        name='last_name'
        type='text'
        placeholder='Enter Last Name'
        label='Last Name'
        className='mb-3'
      />
      <div className='flex flex-col gap-1 mb-3'>
        <Label className='mb-2'>Phone Number</Label>
        <PhoneNumberInput
          name='phone_number'
          placeholder='ex: +20124356762'
          onChange={(value) => setFieldValue('phone_number', value)}
          value={(values as TUser)?.['phone_number']}
        />
        <ErrorMessage
          name='phone_number'
          component={CustomErrorMessage}
        />
      </div>
      <div className='flex flex-col gap-1 mb-3'>
        <Label className='mb-2'>Whatsapp Number</Label>
        <PhoneNumberInput
          name='whatsapp_number'
          placeholder='ex: +20124356762'
          onChange={(value) => setFieldValue('whatsapp_number', value)}
          value={(values as TUser)?.['whatsapp_number']}
        />
        <ErrorMessage
          name='whatsapp_number'
          component={CustomErrorMessage}
        />
      </div>
    </div>
  );
};

export default EditRegistrationInfo;
